import { InjectionToken } from "@angular/core";

export interface ITokenStorage {
  get(): Promise<string | null>;
  set(token: string): Promise<void>;
  clear(): Promise<void>;
}

export const TOKEN_STORAGE = new InjectionToken<ITokenStorage>("TOKEN_STORAGE");
export const MOBILE_TOKEN_KEY = "kiraah-mobile-token";
